// React Query
import { useQuery } from "@tanstack/react-query";

// API's
import { getPayPlanAssignment } from "@/PayPlans/api/assignments/queries";

// Layouts
import EmptyBody from "@/Layouts/components/Basics/EmptyBody";

// Custom Components
import CurrentAssignmentFilter from "@/PayPlans/components/Assignments/CurrentAssignmentFilter";
import PdfPayPlanLayer from "@/PayPlans/views/Layers/Html/Sales/Associates";

// MUI
import { Grid } from "@mui/material";

// Images
import empty from "@/assets/images/commons/empty.png";

type AssignmentDialogProps = Readonly<{
	selectedItem: {
		_id: string;
		available: boolean;
		customComponent: object;
		name: string;
		position: string;
	};
	locationId: string;
	areaOpen: boolean;
}>;
export default function AssignmentDialog(props: AssignmentDialogProps) {
	const { selectedItem = null, locationId = "", areaOpen = false } = props;

	const { data: currentPayPlansArray, isLoading } = useQuery({
		queryKey: ["payPlanAssignmentCurrentAssignment", selectedItem?._id, locationId],
		queryFn: async () => getPayPlanAssignment(locationId, selectedItem?._id),
		enabled: !!selectedItem?._id && !!locationId,
		staleTime: Infinity,
	});

	if (!selectedItem) {
		return (
			<Grid container className={"!overflow-clip !my-[24px] !ml-[24px] !mr-[10px] !w-[980px] !h-[580px]"}>
				<Grid item xs={12} sx={{ paddingLeft: "40px !important", paddingRight: "40px !important" }}>
					<EmptyBody
						image={empty}
						title={"No Item selected"}
						bodyHeight={"520px"}
						sx={{
							boxShadow: "none !important",
						}}
					/>
				</Grid>
			</Grid>
		);
	}

	return (
		<Grid item className="!overflow-clip !my-[24px] !ml-[24px] !mr-[10px] !w-[980px] !h-[570px]">
			<Grid container direction="column">
				<CurrentAssignmentFilter
					employeesCurrentAssignment={currentPayPlansArray}
					usersByCurrentPayPlanLoading={isLoading}
					isLoading={isLoading}
					areaOpen={areaOpen}
				/>
				<Grid container>
					<Grid item sx={{ paddingLeft: "15px" }} className="!w-full">
						<PdfPayPlanLayer selected={selectedItem} />
					</Grid>
				</Grid>
			</Grid>
		</Grid>
	);
}
